<template>
  <div class="coupon">
    <!-- <van-coupon-cell :coupons="coupons" :chosen-coupon="chosenCoupon" @click="showList = true" /> -->
    <!-- 优惠券列表 -->
    <van-popup v-model="showList" position="bottom">
      <van-coupon-list
        :coupons="coupons"
        :chosen-coupon="chosenCoupon"
        :disabled-coupons="disabledCoupons"
        @change="onChange"
        @exchange="onExchange"
      />
    </van-popup>
  </div>
</template>


<script>
export default {
  data() {
    return {
      // 优惠券列表
      couponList: [],
      showList: true,
      chosenCoupon: -1,
      coupons: [],
      disabledCoupons: []
    };
  },

  computed: {},

  created() {
    this.getCouponList();
  },

  computed: {
    preOrderId() {
      return this.$route.params.preOrderId;
    },
    totalPrice() {
      return this.$route.params.totalPrice;
    }
  },

  methods: {
    // 获取优惠券列表
    async getCouponList() {
      let preOrderId = this.preOrderId;
      let totalPrice = this.totalPrice;
      let url = "/coupon/all";
      this.$loading(true);
      try {
        let res = await this.$get(url, { preOrderId });
        this.couponList = res.list;
        // 根据totalPrice把优惠券分成可用和不可用两类
        res.list.forEach(item => {
          if (!item.conditionValue || totalPrice * 100 >= item.conditionValue) {
            this.coupons.push(item);
          } else {
            item.reason = "商品总价达不到要求";
            this.disabledCoupons.push(item);
          }
        });
      } catch (error) {
        this.$fail(error);
      }
      this.$loading(false);
    },

    onChange(index) {
      this.chosenCoupon = index;
      let discount = 0;
      if (index !== -1) {
        let coupon = this.coupons[index];
        console.log(coupon);
        if (coupon.type === "01") {
          discount = coupon.value;
        } else {
          discount = coupon.value * this.totalPrice;
        }
      }
      // console.log('discount',discount);

      this.$store.commit("updateDiscount", discount);
      this.$router.go(-1);
    },
    onExchange(code) {
      // this.coupons.push(coupon);
    }
  }
};
</script>

<style lang="less">
.coupon {
  .van-coupon-list {
    min-height: 100vh;
  }
}
</style>